import React from "react";
import { Box, Container, Typography, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  PRIVACY_POLICY_META,
  PRIVACY_POLICY_SECTIONS,
  TERMS_AND_CONDITIONS_META,
  TERMS_AND_CONDITIONS_SECTIONS,
} from "../../constants/termsAndPrivacy";

const TermsAndConditions = ({ mode = "privacy" }) => {
  const navigate = useNavigate();
  const isTerms = mode === "terms";
  const meta = isTerms ? TERMS_AND_CONDITIONS_META : PRIVACY_POLICY_META;
  const sections = isTerms ? TERMS_AND_CONDITIONS_SECTIONS : PRIVACY_POLICY_SECTIONS;
  const pageTitle = isTerms ? `Terms and Conditions for ${meta.companyName}` : `Privacy Policy for ${meta.companyName}`;

  const renderSection = (section) => {
    if (section.blocks) {
      return (
        <Box key={section.title} sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 1 }}>
            {section.title}
          </Typography>
          {section.blocks.map((block, i) =>
            block.type === "list" ? (
              <Box key={i} component={block.ordered ? "ol" : "ul"} sx={{ pl: 3, m: 0 }}>
                {block.items.map((item, j) => (
                  <Typography key={j} component="li" sx={{ fontSize: 14, color: "#555", lineHeight: 1.7 }}>
                    {item}
                  </Typography>
                ))}
              </Box>
            ) : (
              <Typography key={i} sx={{ fontSize: 14, color: "#555", lineHeight: 1.7, mb: 1.5 }}>
                {block.text}
              </Typography>
            )
          )}
        </Box>
      );
    }

    if (section.subsections) {
      return (
        <Box key={section.title} sx={{ mb: 3 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 1 }}>
            {section.title}
          </Typography>
          {section.subsections.map((sub) => (
            <Box key={sub.subtitle} sx={{ mb: 1.5, pl: 1 }}>
              <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 0.5 }}>
                {sub.subtitle}
              </Typography>
              {sub.body && (
                <Typography sx={{ fontSize: 14, color: "#555", lineHeight: 1.7 }}>
                  {sub.body}
                </Typography>
              )}
              {sub.items?.map((item, i) => (
                <Typography key={i} sx={{ fontSize: 14, color: "#555", lineHeight: 1.7 }}>
                  • {item}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      );
    }

    return (
      <Box key={section.title} sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 600, fontSize: 15, mb: 1 }}>
          {section.title}
        </Typography>
        {section.body && (
          <Typography sx={{ fontSize: 14, color: "#555", lineHeight: 1.7 }}>
            {section.body}
          </Typography>
        )}
        {section.items?.map((item, i) => (
          <Typography key={i} sx={{ fontSize: 14, color: "#555", lineHeight: 1.7 }}>
            • {item}
          </Typography>
        ))}
      </Box>
    );
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f9f9f9", py: 4 }}>
      <Container maxWidth="md">
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3, cursor: "pointer", width: "fit-content" }}
          onClick={() => navigate(-1)}
        >
          <ArrowBackIcon sx={{ fontSize: 20, color: "#333" }} />
          <Typography sx={{ fontSize: 14, color: "#333" }}>Back</Typography>
        </Box>

        <Box sx={{ backgroundColor: "#fff", borderRadius: 2, p: 4, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            {pageTitle}
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#888", mb: 3 }}>
            Last Updated: {meta.lastUpdated}
          </Typography>
          <Divider sx={{ mb: 3 }} />

          {sections.map(renderSection)}
        </Box>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
